angular.module( 'acme.view.application.membership.list.modals.member', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.list.modals.member.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipListModalsMember = {
        name: 'application.membership.list.modals.member',
        url: '/membership/list/modals/member',
        views: {
          "main": {
            controller: 'MembershipListModalsMemberController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/list/modals/member/member.tpl.html'
          }
        },
        data: {
          pageTitle: '    '
        }
      };

    $stateProvider
      .state(membershipListModalsMember);
});
